/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Filter_Type_LabelInputs */



/**
* | output |
* | --- |
* | "Filter by type" |
*
* @param {Manual_Qc_Filter_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_filter_type_label = /** @type {((inputs?: Manual_Qc_Filter_Type_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Filter_Type_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filtrer par type")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nach Typ filtern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filtra per tipo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фильтр по типу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filtrar por tipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按类型筛选")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイプでフィルタリング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रकार के अनुसार फ़िल्टर करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Filtrar por tipo")
	return /** @type {LocalizedString} */ ("Filter by type")
});